import EnvInfoRibbon from './EnvInfoRibbon';

export default EnvInfoRibbon;
